import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTermsAndConditions } from '../services/legalService';
import {useLang} from "../context/LanguageContext";
import BackButton from "../components/BackButton";
import Footer from "../components/Footer"; // Make sure this import path is correct

const TermsPage = () => {
  const navigate = useNavigate();
  const [termsHTML, setTermsHTML] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {language} = useLang();

  useEffect(() => {
    getTermsAndConditions(language)
      .then((terms) => {
        setTermsHTML(terms);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load terms and conditions.");
        setLoading(false);
      });
  }, [language]);

  if (loading) {
    return (
      <div className="bg-gray-100 min-h-screen p-5 flex flex-col">
          <BackButton onClick={() => navigate('/')}/>
        <div>Loading terms and conditions...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-gray-100 min-h-screen p-5 flex flex-col">
        <BackButton onClick={() => navigate('/')}/>
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen">
        <BackButton onClick={() => navigate('/')}/>
      <div 
        className="prose pt-16"
        dangerouslySetInnerHTML={{ __html: termsHTML }}
      />
        <Footer />
    </div>
  );
};

export default TermsPage;
